import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BREAKPOINTS_MAX } from "@dexibit/styles";

import type { RootState } from "../../store";

export interface PanelContent {
  componentType: string;
  props?: Record<string, unknown>;
}

export interface ChatState {
  leftSidebar: {
    collapsed: boolean;
  };
  rightSidebar: {
    collapsed: boolean;
    content: PanelContent | null;
  };
}

export const selectChat = createSelector(
  (state: RootState) => state,
  (state) => state.chat,
);

export const selectLeftSidebar = createSelector(selectChat, (chat) => chat.leftSidebar);

export const selectRightSidebar = createSelector(selectChat, (chat) => chat.rightSidebar);

export const chatSlice = createSlice({
  name: "chat",
  initialState: {
    leftSidebar: {
      collapsed: window.innerWidth <= BREAKPOINTS_MAX.mobile,
    },
    rightSidebar: {
      collapsed: true,
      content: null,
    },
  } as ChatState,
  reducers: {
    setLeftSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.leftSidebar.collapsed = action.payload;
    },
    toggleLeftSidebarCollapse: (state) => {
      state.leftSidebar.collapsed = !state.leftSidebar.collapsed;
    },
    setRightSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.rightSidebar.collapsed = action.payload;
    },
    openRightSidebar: (
      state,
      action: PayloadAction<{ content: PanelContent; collapsed?: boolean }>,
    ) => {
      state.rightSidebar.collapsed = action.payload.collapsed ?? false;
      state.rightSidebar.content = action.payload.content;
    },
    closeRightSidebar: (state) => {
      state.rightSidebar.collapsed = true;
      state.rightSidebar.content = null;
    },
  },
});

export const {
  setLeftSidebarCollapsed,
  toggleLeftSidebarCollapse,
  setRightSidebarCollapsed,
  openRightSidebar,
  closeRightSidebar,
} = chatSlice.actions;
